import React, {useRef, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"
import {useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import * as Yup from "yup";
import {
    FORM,
    INTERNATIONAL,
    LB_BACKGROUND,
    LB_CODE, LB_DESCRIPTION,
    LB_ICON, LB_STATUS,
    LB_TITLE,
    REQUIRED
} from "../../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {amenityService} from "../../../../jwt/_services/hotel/amenityService";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {roomAmenityService} from "../../../../jwt/_services/hotel/roomAmenityService";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import Separator from "../../../../components/Separator";
import {PH_BACKGROUND, PH_CODE, PH_DESCRIPTION, PH_ICON, PH_TITLE} from "../../../../components/i18n/placeHolders";
import {FL_CATEGORY, FL_TYPE_AMENITY} from "../../../../components/i18n/formLabels";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {hotelCategoryProvider} from "../../../../providers/hotelCategoryProvider";
import {amenityTypeProvider} from "../../../../providers/amenityTypeProvider";
import AmenitiesLangs from "../../../hotel/suiteController/amenities/_langs";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import LabelLangs from "../../../configuration/label/_langs";
import {labelService} from "../../../../jwt/_services/configuration/labelService";
import {pageLabelService} from "../../../../jwt/_services/landings/pageLabelService";
import Switch from "react-bootstrap-switch";
import {sectionService} from "../../../../jwt/_services/landings/sectionService";
import {pageSectionService} from "../../../../jwt/_services/landings/pageSectionService";

const SectionsForm = (props) => {
    const pageState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:page, app } = pageState?.data || {};

    const path = `${props.path}/sections`;
    const componentState = useSelector(state => getStateByPath(state, path));

    const { editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const [status, setStatus] = useState(domainObject?.status || true);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);


    const validationSchema = Yup.object().shape({
        title: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            title: domainObject?.title,
            description: domainObject?.description,
            background: domainObject?.background,
        }
    });

    const onSubmit = async (data, _) => {
        let labelRequest = {
            fbDataBase,
            item : {
                ...data,
                status
            }
        };



        if(editMode){
            labelRequest.item.id = domainObject?.id
            await sectionService.updateItem(domainObject?.id, labelRequest) // actualizar la amenidad
            return
        }

        const sectionResponse = await sectionService.saveItem(labelRequest) // guardar la amenidad

        const requestData = {
            fbDataBase,
            item: {
                page: { id: page?.id },
                section: { id: sectionResponse?.id }
            }
        }

        genericIndexedActions.save(path, pageSectionService, requestData, closeForm) // vincular la amenidad con el tipo de habitación

    };

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const closeForm = () => {
        reset();
        props.toggle()
    }


    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>{FORM}
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{LB_TITLE}</Label>
                                <Input
                                    type="text"
                                    name="title"
                                    placeholder={PH_TITLE}
                                    innerRef={register}
                                />
                                { errors.title && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.title?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label>{LB_BACKGROUND}</Label>
                                <Input
                                    type="text"
                                    name="background"
                                    placeholder={PH_BACKGROUND}
                                    innerRef={register}
                                />
                                { errors.background && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.background?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_STATUS}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={ () => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_DESCRIPTION}</Label>
                                <Input
                                    type="textarea"
                                    name="description"
                                    placeholder={PH_DESCRIPTION}
                                    innerRef={register}
                                />
                                { errors.description && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.description?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>

                {
                    showModal && <LogHistoryModal
                        ref={modalRef}
                        item={domainObject}
                    />
                }
            </Card>
        </Form>
    </Modal>
}

export default SectionsForm;